import { TemplatedMsgWrapper } from '@src/types';
import { FormattedMessage } from 'react-intl';
import TemplateList from '../AdminHome/Contact/TemplateList';
import './selectTemplate.css';

interface ISelectTemplate {
  selectedTemplate: TemplatedMsgWrapper;
  templatedMsgs: TemplatedMsgWrapper[];
  onSelectedTemplate: (templateId: number) => void;
  onShowTemplates: () => void;
  showTemplates: boolean;
  allowClass: boolean;
}

const SelectTemplate = ({
  selectedTemplate,
  templatedMsgs,
  onSelectedTemplate,
  onShowTemplates,
  showTemplates,
  allowClass = true,
}: ISelectTemplate) => {
  const activeTemplates = templatedMsgs
    .map(tm => tm.templatedMsg)
    .filter(item => item.status === 'ACTIVE');

  return (
    <div className={showTemplates && allowClass ? 'st-container' : ''}>
      {selectedTemplate && (
        <div className="st-body">
          <FormattedMessage id="TemplatedMsg.templateToStart" /> (
          {selectedTemplate.templatedMsg?.name}).
          {templatedMsgs.length > 1 && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              style={{ marginLeft: '5px' }}
              // eslint-disable-next-line no-script-url
              href="javascript:;"
              onClick={onShowTemplates}
            >
              {showTemplates ? (
                <FormattedMessage id="TemplatedMsg.keepTemplate" />
              ) : (
                <FormattedMessage id="TemplatedMsg.anotherTemplate" />
              )}
            </a>
          )}
        </div>
      )}

      {showTemplates && (
        <TemplateList
          activeTemplates={activeTemplates}
          selectedTemplateId={selectedTemplate.templatedMsg.id}
          handleSelectedTemplate={onSelectedTemplate}
        />
      )}
    </div>
  );
};

export default SelectTemplate;
